import { h, ComponentChildren } from 'preact'

interface Props { children: ComponentChildren }

const PillContainer = ({ children }: Props) =>
  <div class='preact-pill-container'>{children}</div>

export default PillContainer
